module.exports = __webpack_public_path__ + "widget.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[name].[ext]!./src/widgetApp/widget.html
 ** module id = 184
 ** module chunks = 4
 **/